var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itemPackages"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('ItemPackagesTable',{on:{"create-item-package":_vm.onCreateItemPackage,"edit-item-package":_vm.onEditItemPackage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }